(() => {
  if (window.__protacticRestockReady) return;
  window.__protacticRestockReady = true;

  class ProtacticRestock {
    constructor(root) {
      this.root = root;
      this.slides = [...root.querySelectorAll('[data-ptr-slide]')];
      this.current = 0;
      this.interval = null;
      this.autoplay = root.dataset.autoplay === 'true';
      this.speed = Math.max(3000, Number(root.dataset.autoplaySpeed) || 6000);
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!this.slides.length) return;

      root.querySelectorAll('[data-ptr-prev]').forEach((button) => button.addEventListener('click', () => this.show(this.current - 1, true)));
      root.querySelectorAll('[data-ptr-next]').forEach((button) => button.addEventListener('click', () => this.show(this.current + 1, true)));
      root.querySelector('[data-ptr-viewport]')?.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.show(this.current + (event.key === 'ArrowRight' ? 1 : -1), true);
      });

      root.addEventListener('mouseenter', () => this.stop());
      root.addEventListener('mouseleave', () => this.start());
      root.addEventListener('focusin', () => this.stop());
      root.addEventListener('focusout', (event) => {
        if (!root.contains(event.relatedTarget)) this.start();
      });

      this.show(0, false);
      this.start();
    }

    show(index, restart) {
      if (!this.slides.length) return;
      this.current = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === this.current;
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      this.root.querySelectorAll('[data-ptr-current]').forEach((node) => {
        node.textContent = String(this.current + 1).padStart(2, '0');
      });
      this.root.style.setProperty('--ptr-progress', `${((this.current + 1) / this.slides.length) * 100}%`);
      if (restart) {
        this.stop();
        this.start();
      }
    }

    start() {
      if (!this.autoplay || this.reducedMotion || this.slides.length < 2 || this.interval) return;
      this.interval = window.setInterval(() => this.show(this.current + 1, false), this.speed);
    }

    stop() {
      window.clearInterval(this.interval);
      this.interval = null;
    }
  }

  const initialize = (scope = document) => {
    scope.querySelectorAll?.('[data-ptr-restock]').forEach((root) => {
      if (root.dataset.ptrReady === 'true') return;
      root.dataset.ptrReady = 'true';
      root.ptrRestock = new ProtacticRestock(root);
    });
  };

  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll?.('[data-ptr-restock]').forEach((root) => root.ptrRestock?.stop());
  });
  document.addEventListener('shopify:block:select', (event) => {
    const slide = event.target.closest?.('[data-ptr-slide]');
    const root = slide?.closest('[data-ptr-restock]');
    if (!slide || !root?.ptrRestock) return;
    root.ptrRestock.show(Number(slide.dataset.slideIndex), false);
    root.ptrRestock.stop();
  });
})();
